class InstafeedAccessibility {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.enhanceAccessibility());
    } else {
      this.enhanceAccessibility();
    }

    this.observeInstafeed();
  }

  enhanceAccessibility() {
    const instafeedItems = document.querySelectorAll('.instafeed-new-layout-item-container[role="link"]');

    instafeedItems.forEach((item, index) => {
      if (!item.hasAttribute('aria-label')) {
        const feedId = item.getAttribute('data-instafeed-open-id') || `${index + 1}`;
        const ariaLabel = `View Instagram post ${feedId.split('-')[0]}`;
        item.setAttribute('aria-label', ariaLabel);
      }
    });
  }

  observeInstafeed() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (
                node.classList?.contains('instafeed-new-layout-item-container') ||
                node.querySelector?.('.instafeed-new-layout-item-container')
              ) {
                shouldUpdate = true;
              }
            }
          });
        }
      });

      if (shouldUpdate) {
        this.enhanceAccessibility();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

new InstafeedAccessibility();
